import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersSiteFilterComponent } from './components/scripts/usersSiteFilter.component';
import { UsersSiteComponent } from './components/scripts/usersSite.component';
import { AuthGuard } from '../authentication/services/auth.guard.service';


const usersRoutes: Routes = [
 {
    path: 'usersSite', component: UsersSiteFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'UserSiteManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: UsersSiteFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
  {
    path: 'usersSite/edit/:userId',
    component: UsersSiteComponent,
    data: {
      roles: ['Admin', 'UserSiteManager']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(usersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class UsersSiteRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/users/users-routing.module.ts